import { render, staticRenderFns } from "./TestNotice.vue?vue&type=template&id=c625e996&scoped=true&"
import script from "./TestNotice.vue?vue&type=script&lang=js&"
export * from "./TestNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c625e996",
  null
  
)

export default component.exports